import { render, staticRenderFns } from "./AccordionBlock.vue?vue&type=template&id=5eb9e503&"
import script from "./AccordionBlock.vue?vue&type=script&lang=js&"
export * from "./AccordionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/app/components/UI/UiIcon.vue').default})
